import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import Button from '@/components/Button';
import { IconPlus } from '@/components/icon/tabler/IconPlus';
import { IconTag } from '@/components/icon/tabler/IconTag';
import { useTranslate } from '@/state/i18n';

interface Props {
  /** A status tab is selected: the account may have offers in other tabs. */
  filtered: boolean;
  onCreate: () => void;
}

/** Empty list: no offers yet, with the first call to action, or an empty tab. */
const OffersEmptyState = ({ filtered, onCreate }: Props) => {
  const t = useTranslate('domain.offers.components.OffersEmptyState');

  return (
    <Stack alignItems="center" textAlign="center" gap={1.5} sx={{ py: 8, px: 2 }}>
      <IconTag color="primary" sx={{ fontSize: 32 }} />
      <Typography variant="subtitle1" fontWeight={600}>
        {filtered ? t('filteredTitle') : t('title')}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 440 }}>
        {filtered ? t('filteredHint') : t('hint')}
      </Typography>
      {filtered ? null : (
        <Button variant="contained" startIcon={<IconPlus />} onClick={onCreate}>
          {t('create')}
        </Button>
      )}
    </Stack>
  );
};

export default OffersEmptyState;
